export const ERRORS_TRANSLATE = {
	unsupported_media_type: 'Неподдерживаемый тип медиа',
	internal_server_error: 'Внутренняя ошибка сервера',
	not_found: 'по данному запросу ничего не было найдено',
	'500': 'error-server-500',
	'404': 'Пользователь не был найден',
	'401': 'error-server-401',
	DEFAULT: 'error-server-default'
} as Record<string, string>;
